import React, { createContext, useContext, useState } from "react";
import {
  IBrochureContext,
  IBrochureData,
} from "../exports/interfaces";

const BrochureContext = createContext<IBrochureContext>({
  brochureData: [],
  setBrochureData: () => null,

  undergraduateBrochureData: [],
  setUndergraduateBrochureData: () => null,

  mppBrochureData: [],
  setMppBrochureData: () => null,
});

export const useBrochureContext = () => useContext(BrochureContext);

export const BrochureProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [brochureData, setBrochureData] = useState<IBrochureData[]>([]);

  const [undergraduateBrochureData, setUndergraduateBrochureData] =
    useState<IBrochureData[]>([]);

  const [mppBrochureData, setMppBrochureData] =
    useState<IBrochureData[]>([]);

  return (
    <BrochureContext.Provider
      value={{
        brochureData,
        setBrochureData,

        undergraduateBrochureData,
        setUndergraduateBrochureData,

        mppBrochureData,
        setMppBrochureData,
      }}
    >
      {children}
    </BrochureContext.Provider>
  );
};